const StudentSection = () => {
    return (
        <section id="student">
            <div className="lines2">
                <div className="line line1"></div>
                <div className="line line2"></div>
                <div className="line line3"></div>
                <div className="line line4"></div>
            </div>
            <div className="content">
                <div className="title">
                    <h2>Préparez vos <span>étudiants</span> <br />pour une carrière à l’internationale</h2>
                </div>
                <div className="text">
                    <p>Donnez à vos élèves un avantage clé avec Polyglow. <br />Notre application interactive leur fournit les compétences linguistiques essentielles, enrichissant leur profil professionnel et les préparant à exceller dans un marché globalisé. Ajoutez un outil précieux à leur formation pour les aider à se démarquer dans leur future carrière.</p>
                </div>
            </div>
        </section>
    );
};


export default StudentSection;